import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  template: `
    <div class="flex justify-between gap-4">
      <div class="flex-1">
        <h2 class="orgbrain-mat-dialog-header !mt-0 p-0 mb-2">
          {{ title }}
        </h2>

        <p class="mat-body" *ngIf="!isQuestionAnArray(); else questionArrayTemplate">
          <span [innerHTML]="question"></span>
        </p>
      </div>
      <mat-icon class="text-red-500 fill-icon !text-[48px]  !w-12 !h-12">warning</mat-icon>
    </div>

    <div class="flex justify-end gap-2 items-center mt-8">
      <button
        mat-button
        color="primary"
        class="action-button"
        id="delete_dialog_no_button"
        class=" hover:!bg-orgbrain-background/80 !text-orgbrain-gray !transition-all"
        (click)="dialogRef.close(false)"
        cdkFocusInitial
      >
        {{ noOptionTitle }}
      </button>
      <button
        mat-flat-button
        class="action-button !bg-red-500 hover:!bg-red-600 !text-orgbrain-background !transition-all !min-w-0 p-2 !pl-2"
        id="delete_dialog_yes_button"
        (click)="dialogRef.close(true)"
      >
        <div class="flex gap-2 items-center">
          <mat-icon>delete</mat-icon>
          {{ yesOptionTitle }}
        </div>
      </button>
    </div>
    <ng-template #questionArrayTemplate>
      <p class="mat-body" *ngFor="let q of question" [innerHTML]="q"></p>
    </ng-template>
  `,
  styleUrls: ['dialog.component.scss'],
  standalone: false,
})
export class DeleteDialogComponent {
  subtitle: string;
  yesOptionTitle: string;
  noOptionTitle: string;
  alternativeOptionTitle: string;
  title: string;
  question: string | string[];
  public dialogRef = inject(MatDialogRef<DeleteDialogComponent>);
  public data = inject(MAT_DIALOG_DATA);

  isQuestionAnArray() {
    return Array.isArray(this.question);
  }
}
